// extracted by mini-css-extract-plugin
module.exports = {"landing-wrapper":"styles_landing-wrapper__FfKLB","mobile":"styles_mobile__LvHGs"};